import { render, staticRenderFns } from "./CalendarDayEventList.vue?vue&type=template&id=5ef4c484&scoped=true&"
import script from "./CalendarDayEventList.vue?vue&type=script&lang=js&"
export * from "./CalendarDayEventList.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDayEventList.vue?vue&type=style&index=0&id=5ef4c484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef4c484",
  null
  
)

export default component.exports